// this file based on https://react.i18next.com/guides/quick-start
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import english from '../translations/English.json'
import german from '../translations/German.json'
import italian from '../translations/Italian.json'
import spanish from '../translations/Spanish.json'
import french from '../translations/French.json'
import chinese from '../translations/Chinese.json'

type LanguageSelection =
  | 'language_select_english'
  | 'language_select_german'
  | 'language_select_spanish'
  | 'language_select_french'
  | 'language_select_italian'
  | 'language_select_chinese'

export type Language = {
  lang: string
  langSelect: LanguageSelection
  langCode: string
}

export const languages: Language[] = [
  {
    lang: 'English',
    langSelect: 'language_select_english',
    langCode: 'en',
  },
  {
    lang: 'German',
    langSelect: 'language_select_german',
    langCode: 'de',
  },
  {
    lang: 'Spanish',
    langSelect: 'language_select_spanish',
    langCode: 'es',
  },
  {
    lang: 'French',
    langSelect: 'language_select_french',
    langCode: 'fr',
  },
  {
    lang: 'Italian',
    langSelect: 'language_select_italian',
    langCode: 'it',
  },
  {
    lang: 'Chinese',
    langSelect: 'language_select_chinese',
    langCode: 'zh',
  },
]

export const languageMap = new Map(languages.map(({ langCode, lang }) => [langCode, lang]))
export const languageNames = languages.map(({ lang }) => lang)
export const languageCodes = languages.map(({ langCode }) => langCode)

const resources = {
  en: {
    translation: english,
  },
  de: {
    translation: german,
  },
  it: {
    translation: italian,
  },
  es: {
    translation: spanish,
  },
  fr: {
    translation: french,
  },
  zh: {
    translation: chinese,
  },
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    supportedLngs: languageCodes,
    fallbackLng: 'en',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
    },
  })

export default i18n
